// extracted by mini-css-extract-plugin
export default {"m":"_60dde7d455","title":"_70d8596e67","feedback_inner_title":"f389dd8233","textarea":"_69293f04c3","radio":"a1541fa94d","text":"c321aca731"};